import * as React from "react";

import { IconProps } from "./Icon.model";

export function AnalyticsUpIcon({
  size = 16,
  fill = "currentColor",
}: IconProps) {
  const fillColor =
    fill === "currentColor" ? "currentColor" : `var(--${fill}-a8)`;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 15 15"
    >
      <path
        fill={fillColor}
        d="M8.038 1.167c1.46 0 2.607 0 3.503.12.918.124 1.647.381 2.219.953s.83 1.301.953 2.219c.12.896.12 2.043.12 3.503v.076c0 1.46 0 2.608-.12 3.503-.123.918-.381 1.647-.953 2.219s-1.301.83-2.219.953c-.896.12-2.043.12-3.503.12h-.076c-1.46 0-2.607 0-3.503-.12-.918-.123-1.647-.381-2.219-.953s-.83-1.301-.953-2.219c-.12-.896-.12-2.043-.12-3.503v-.076c0-1.46 0-2.607.12-3.503.124-.918.381-1.647.953-2.219s1.301-.83 2.219-.953c.896-.12 2.043-.12 3.503-.12zm-3.371 9a.5.5 0 0 0-.5.5V12a.5.5 0 0 0 1 0v-1.333a.5.5 0 0 0-.5-.5M8 9.5a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 1 0v-2a.5.5 0 0 0-.5-.5m3.333-1.333a.5.5 0 0 0-.5.5V12a.5.5 0 0 0 1 0V8.667a.5.5 0 0 0-.5-.5m-.76-4.665a4 4 0 0 0-.454.059l-.022.002-.845.14a.5.5 0 0 0 .163.986l.482-.079C8.642 6.372 6.635 7.167 4 7.167a.5.5 0 0 0 0 1c2.881 0 5.266-.896 6.755-3.037l.097.34a.5.5 0 0 0 .963-.275l-.213-.74q-.004-.011-.006-.022a3 3 0 0 0-.137-.406.87.87 0 0 0-.362-.414.95.95 0 0 0-.525-.111"
      />
    </svg>
  );
}

export default AnalyticsUpIcon;
